import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { MultiSelect } from "react-multi-select-component";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Pagination from '../../../Components/Pagination/Pagination';
import { getAllTendersCompanies, getIntrestedTenderCompanies, userCompaniesFilter } from '../../../Redux/Action/Dashboard';
import Loader from '../../../Utils/Loader';
import { successNotify } from '../../../Utils/Toast';
import './AllTenders.css';

const AllTenders = () => {
  const dispatch = useDispatch();

  const [saveCompanies, setSaveCompanies] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selected, setSelected] = useState([]);

  const { loading: companiesLoading, allTendersCompaniesData } = useSelector((state) => state.companiesAllTendersGetData)
  const { loading: interestedLoading, interestedCompaniesData } = useSelector((state) => state.getCompaniesFilterData)
  const { loading: tendersLoading, tendersCompaniesData } = useSelector((state) => state.interestedTenderCompaniesData)

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [limit]);

  useEffect(() => {
    dispatch(getAllTendersCompanies())
  }, [])

  useEffect(() => {
    dispatch(getIntrestedTenderCompanies(currentPage, limit))

    return () => {
      dispatch({ type: "GET_ALL_TENDERS_RESET" })
    }
  }, [currentPage, limit])

  useEffect(() => {
    if (allTendersCompaniesData?.data) {
      const options = allTendersCompaniesData.data.map((company) => ({
        value: company.company,
        label: company.company,
        isSelected: company.is_selected_company !== null
      }));

      setSaveCompanies(options);

      const preSelected = options.filter(company => company.isSelected);
      setSelected(preSelected);
    }
  }, [allTendersCompaniesData]);

  useEffect(() => {
    if (interestedCompaniesData?.statusCode === 200) {
      successNotify("Tender Saved Successfully!")
      dispatch(getAllTendersCompanies());
      dispatch(getIntrestedTenderCompanies(currentPage, limit))
      dispatch({ type: "SAVE_USER_INTERESTED_COMPANIES_RESET" })
    }
  }, [interestedCompaniesData])

  const handleChange = (selected) => {
    setSelected(selected);

    const companiesValues = selected?.map((company) => company.value);

    const data = {
      checkedComapanyItems: companiesValues
    }

    dispatch(userCompaniesFilter(data));
  };

  return (
    <div className='table_main'>
      <div className='application_main'>

        <h1 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          All Tenders
        </h1>

        <div className='companies_dropdown_wrapper pb-3' style={{ borderBottom: "1px solid #8080804d" }}>
          <Form.Group className="form_field">
            <Form.Label>Select Companies </Form.Label>

            <MultiSelect
              options={saveCompanies}
              value={selected}
              onChange={handleChange}
              labelledBy="Select"
              className='companies_multi_select'
              isLoading={companiesLoading || interestedLoading || tendersLoading}
              disabled={companiesLoading || interestedLoading || tendersLoading}
            />
          </Form.Group>
        </div>

        {
          <div style={{ margin: "20px" }}>
            {
              tendersLoading ? <div className='py-3'>
                <Loader />
              </div> :
                <>
                  <Row style={{ gap: "15px 0" }}>
                    {
                      tendersCompaniesData?.data?.results?.map((t, i) => {
                        return (
                          <Col md={4} style={{ marginTop: "15px" }} key={i}>
                            <div className='interested_tender_box'>
                              <Row className='align-items-center'>
                                <Col md={12}>
                                  <div>
                                    <p><span>Company Name: </span> {t.company} </p>
                                    <p><span>Total Tenders: </span> {t.tenderCount} </p>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='d-flex' style={{ gap: "15px" }}>
                                    {
                                      t.tenderCount > 0 ?
                                        <Link to={`/dashboard/tender/${t.company}?tender=${t.tenderCount}`} className='selected_tenders'>
                                          Show Tenders
                                        </Link> :
                                        <Link disabled className='selected_tenders disabled'>
                                          Show Tenders
                                        </Link>
                                    }
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        )
                      })
                    }
                    <Col md={12}>
                      {
                        tendersCompaniesData?.data?.results?.length === 0 &&
                        <div className='no_data_dound'> No Company Selected. Please select a company from the dropdown above. </div>
                      }
                    </Col>
                  </Row>
                  {
                    tendersCompaniesData?.data?.results?.length > 0 &&
                    <Pagination
                      totalPages={tendersCompaniesData?.data?.meta?.totalPages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      setLimit={setLimit}
                      limit={limit} />
                  }
                </>
            }
          </div>
        }
      </div>
    </div>
  )
}
export default AllTenders
